var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 47,
    viewBox: "0 0 27 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1402 47C22.1533 47 21.166 46.6175 20.4139 45.8525L1.12992 26.2692C-0.376641 24.7393 -0.376641 22.2607 1.12992 20.7308L20.4139 1.14746C21.9205 -0.382487 24.3611 -0.382487 25.8677 1.14746C27.3742 2.67741 27.3742 5.15592 25.8677 6.68587L9.30995 23.5L25.8701 40.3172C27.3766 41.8471 27.3766 44.3256 25.8701 45.8556C25.1168 46.6206 24.1285 47 23.1402 47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageLeftArrow);
export default __webpack_public_path__ + "static/media/HomePage_leftArrow.634039025e1b617d24770e3066176bdb.svg";
export { ForwardRef as ReactComponent };